var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 19.067c.033 1.502 1.493 2.412 2.773 1.696l10.286-6.154c.56-.334.941-.948.941-1.67 0-.72-.381-1.334-.94-1.67L8.772 5.124c-1.28-.716-2.74.185-2.773 1.69z"
  })));
};
export default SvgPlay;